// K.7 — czyszczenie HTML wklejanego z Worda/innych edytorów ZANIM TipTap go sparsuje.
// Cel: wkleić czystą treść (akapity, listy, pogrubienie/kursywa, pigułki zmiennych),
// a wyrzucić śmieci Worda (mso-*, <o:p>, <font>, komentarze warunkowe, inline style/kolory/fonty),
// żeby wklejony tekst przyjął domyślny styl umowy, nie styl Worda.
//
// To NIE jest warstwa bezpieczeństwa (tym jest sanitizeSectionHtml na serwerze + DOMPurify
// w podglądzie) — to porządkowanie wejścia. Ostateczne filtrowanie i tak robi schema TipTap.
// Czysta funkcja (regex, bez DOM) — działa w przeglądarce i jest testowalna.
//
// WAŻNE: zachowujemy `data-variable` (pigułki zmiennych) i `href` (linki) — czyścimy tylko
// atrybuty prezentacyjne (style/class/lang/align/...), więc kopiuj-wklej pigułek w edytorze działa.

export function cleanPastedHtml(html) {
  return String(html == null ? '' : html)
    // bloki <style>/<script>/<xml>/<title> WRAZ Z TREŚCIĄ — Word osadza wyspy CSS/XML,
    // które inaczej ProseMirror potrafi wrzucić jako tekst (blok CSS na górze sekcji).
    .replace(/<(style|script|xml|title)\b[^>]*>[\s\S]*?<\/\1>/gi, '')
    // komentarze HTML, w tym warunkowe MS Office <!--[if ...]> ... <![endif]-->
    .replace(/<!--[\s\S]*?-->/g, '')
    // tagi z przestrzeni nazw Office: <o:p>, </o:p>, <w:sdt>, <m:...>, <v:...>
    .replace(/<\/?[a-z][a-z0-9]*:[^>]*>/gi, '')
    // stare tagi prezentacyjne <font ...> / </font> (zostawiamy ich treść)
    .replace(/<\/?font\b[^>]*>/gi, '')
    // atrybuty prezentacyjne (podwójne i pojedyncze cudzysłowy) — w tym style z fontami/kolorami.
    // NIE zdejmujemy `start` — to semantyczny atrybut <ol start="N">, który backend dopuszcza.
    .replace(/\s(?:style|class|lang|align|width|height|valign|dir|face|color|bgcolor)\s*=\s*"[^"]*"/gi, '')
    .replace(/\s(?:style|class|lang|align|width|height|valign|dir|face|color|bgcolor)\s*=\s*'[^']*'/gi, '');
}

export default cleanPastedHtml;
